
export default {
    searchLandings(params) {
        let path = '/publisher/landings.search';
        params = params || {};
        params.page = 1;
        return this.makeRequest(path, params);
    },

    saveLanding(params) {
        let path = '/publisher/landings.create';
        params = params || {};
        return this.makeRequest(path, params);
    }
};
